export const DROPDOWN = 'dropdown';
export const TEXTBOX = 'textbox';
export const RADIO = 'radio';
export const SLIDER = 'slider';



// WEBPACK FOOTER //
// ./src/app/core/constants.ts